import { render, staticRenderFns } from "./List-Permission-Roles.vue?vue&type=template&id=67d04634"
import script from "./List-Permission-Roles.vue?vue&type=script&lang=js"
export * from "./List-Permission-Roles.vue?vue&type=script&lang=js"
import style0 from "./List-Permission-Roles.vue?vue&type=style&index=0&id=67d04634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports